jQuery(document).ready(function ($) {
  $('.product-form__cart-submit').click(function (e) {
    e.preventDefault();
    console.log('button Cart');
    var formID = $(this).parents('.product-form').attr('id');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: $('#' + formID).serialize(),
      success: function (data) {

        //console.log(data);
        $('#cart-items').empty();
        loadMinicart();
        $('html').addClass('minicart-open');
        $('.minicart-panel').addClass('open');

      },
      error: console.log('Cart Add Error'),
    });
  });

  $('.continue-shopping').click(function () {
    $('html').removeClass('minicart-open');
  })
  $('.filters-toolbar__item .menu-link a').click(function (e) {
    e.preventDefault();
    var newUrl = $(location).attr('href');
    if ($(this).parent().hasClass('active')) {
      $('.filters-toolbar__item .menu-link').removeClass('active');
      $('.link-clear-filter').hide();
    } else {
      $('.filters-toolbar__item .menu-link').removeClass('active');
      $(this).parent().addClass('active');
      var newUrl = $(this).attr('href');
      $('.link-clear-filter').show();
      if ($(this).parent().hasClass('link-clear-filter'))
        $('.link-clear-filter').hide();
    }
    //console.log(newUrl);
    $.get({
      url: newUrl,
      success: function (data) {
        var newProductsWrapper = $(data).find('#Collection');
        var newProductsHtml = newProductsWrapper.html();
        $('#Collection').html(newProductsHtml);
      }
    });
  })

  $('.expand-title').click(function (e) {
    e.preventDefault();
    if ($(this).closest('.expand-tab').hasClass('active'))
      $(this).closest('.expand-tab').removeClass('active')
    else
      $(this).closest('.expand-tab').addClass('active')
  });
});

function loadMinicart(doneCallback) {
  var xhr = new XMLHttpRequest();
  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 300) {
      var wrapper = document.querySelector('#cart-items');
      if (!wrapper) return;
      wrapper.innerHTML = '';
      var json = JSON.parse(xhr.response);
      if (json.items.length) {
        document.getElementById("minicart-panel-items-loading").innerHTML = null;
        for (var i = 0; i < json.items.length; i++) {
          var newDiv = document.createElement('div')
          newDiv.innerHTML = renderCartItem(json.items[i], i)
          wrapper.appendChild(newDiv)
        }
      } else if (!json.items.length) {
        document.getElementById("minicart-panel-items-loading").innerHTML = "Your cart is empty";
      }
      var totalPrice = json.total_price / 100;
      if (totalPrice > 0) {
        document.getElementById('minicartTotalPrice').innerHTML = '$' + totalPrice.toFixed(2);
        jQuery('.minicart-total-price').show();
      } else {
        jQuery('.minicart-total-price').hide();
      }
        document.getElementById('minicartNumberOfItems').innerHTML = json.item_count
        if (typeof loadMinicartComplementary === 'function') loadMinicartComplementary();
    } else {
      console.log('Loading the minicart data has failed');
    }
    if (typeof doneCallback === 'function') doneCallback();
    console.log('The load minicart function has been called');
  };
  xhr.open('GET', 'https://' + window.location.hostname + '/cart.js');
  xhr.send();
}

function renderCartItem(cartItem, i) {
  var itemPrice = cartItem.price / 100 * cartItem.quantity;
  var sellingPlan = "";
  if (cartItem.selling_plan_allocation && cartItem.selling_plan_allocation.selling_plan) {
    sellingPlan = cartItem.selling_plan_allocation.selling_plan.name;
  }
  return '<div class="line-item">' +
    '                   <div class="content" data-id="' + cartItem.id + '" data-price="' + itemPrice.toFixed(2) + '" product-id="' + cartItem.product_id + '">' +
    '                       <div class="item-image">' +
    '                           <a href="' + cartItem.url + '">' +
    '                               <img src="' + cartItem.image + '" alt="">' +
    '                           </a>' +
    '                       </div>' +
    '                       <div class="item-details">' +
    '                           <h4 class="item-title">' +
    '                               <a href="' + cartItem.url + '">' + cartItem.title + '</a>' +
    '                           </h4>' +
    '<div class="selling-plan">' + sellingPlan + '</div>' +
    '                           <div class="item-price">' +
    '                               <div class="text-left"><strong>$' + itemPrice.toFixed(2) + '</strong></div>' +
    '                           </div>' +
    '<div class="item-quantity-wrapper"' +
    '<div class="item-quantity-selector">' +
    '<button class="item-quantity-decrement" onclick="quantityDecrement(this)">-</button>' +
    '<input class="item-quantity-input" type="number" name="updates[]"' +
    'id="' + cartItem.variant_id + '" data-product-id="' + cartItem.product_id + '" data-line="1" value="' + cartItem.quantity + '"' +
    'pattern="[0-9]*">' +
    '<button class="item-quantity-increment" onclick="quantityIncrement(this)">+</button>' +
    '</div>' +
    '</div>' +
    '<div class="spinner" style="display: none;"><div class="fa-pulse"><i class="fa fa-spinner fa-3x fa-fw"></i></div></div>' +
    '                       </div>' +
    '                   </div>' +
    '              </div>'
}

function quantityDecrement(e) {
  var idItem = $(e).parents('.content').attr('data-id');
  var productId = $(e).next('.item-quantity-input').attr('data-product-id');
  var oldVal = parseInt($(e).next('.item-quantity-input').val());
  var newVal = oldVal - 1;
  //console.log('idItem:' + idItem);
  //console.log('oldVal:' + oldVal);
  $(e).parents('.content').find('.spinner').show();
  $(e).parents('.content').addClass('spinner-active');
  cartUpdateAjax(newVal, idItem);
  $(e).next('.item-quantity-input').val(newVal);
  if (newVal == 0) {
    setTimeout(function () {
      $(e).parents('.line-item').parent().remove();
    }, 200);
  }
}

function quantityIncrement(e) {
  var idItem = $(e).parents('.content').attr('data-id');
  var productId = $(e).prev('.item-quantity-input').attr('data-product-id');
  var oldVal = parseInt($(e).prev('.item-quantity-input').val());
  var newVal = oldVal + 1;
  //console.log('idItem:' + idItem);
  //console.log('oldVal:' + oldVal);
  $(e).parents('.content').find('.spinner').show();
  $(e).parents('.content').addClass('spinner-active');
  cartUpdateAjax(newVal, idItem);
  $(e).prev('.item-quantity-input').val(newVal);
}

function cartUpdateAjax(qtyItem, idItem) {
  jQuery.post('/cart/change.js', { quantity: qtyItem, id: idItem })
    .done(function () {
      //console.log("success");
    })
    .fail(function () {
      //console.log("error");
    })
    .always(function (response) {
      console.log(JSON.parse(response.responseText));
      jQuery('.spinner').hide();
      jQuery('.content').removeClass('spinner-active');
      var data = JSON.parse(response.responseText);
      $('#minicartNumberOfItems').html(data.item_count);

      var cartTotal = data.total_price / 100;
      for (var i = 0; i < data.items.length; i++) {
        var cartItem = data.items[i];
        //console.log(cartItem);
        //console.log(cartItem.properties);
        var itemId = data.items[i]['id'];
        var price = data.items[i]['final_line_price'] / 100;
        if (cartItem.properties && cartItem.properties['_ro_unformatted_price']) {
          price = cartItem.properties['_ro_unformatted_price'] / 100 * cartItem.quantity;
        }
        var currencySymbol = '$';
        $('.content[data-id=' + itemId + '] .item-price .text-left strong').text(currencySymbol + price.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'));
      }
      $('.minicart-subtotal').text(currencySymbol + cartTotal.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'));
      if (data.item_count == 0) {
        jQuery('.minicart-total-price').hide();
      } else {
        jQuery('.minicart-total-price').show();
      }
      if (typeof loadMinicartComplementary === 'function') loadMinicartComplementary();
    });

}

document.addEventListener('DOMContentLoaded', function () {
  var BsubWidgetChild = Object.create(BsubWidget);

  Object.setPrototypeOf(BsubWidgetChild, {
    checkBsub: function () {
      if (!document.querySelector('[data-bsub-widget]')) {
        console.debug('BSUB: No widgets detected, skipping initialization.');
        return;
      }

      document.querySelector('.product__price_default').style.display = 'none';
      document.querySelector('.product__price_bold').style.display = 'flex';

      console.debug('BSUB: Successfully initialized widgets.');
    }
  });

  BsubWidgetChild.checkBsub();

  var textSelected = "";
  if (document.querySelector('[data-bsub-widget]')) {
    if (document.querySelector('input[name="bsub-selling-plan-group"]:checked').value == 'once') {
      textSelected = 'One-time Purchase'
    } else {
      textSelected = 'Monthly Subscription - Save'
    }
  }

  if (textSelected != '') {
    document.querySelector('.recurring-type .text').textContent = textSelected;
  }
  checkSellPlanSelected();
  function checkSellPlanSelected() {
    var textSelected, price = "";
    if (document.querySelector('[data-bsub-widget]')) {
      if (document.querySelector('input[name="bsub-selling-plan-group"]:checked').value == 'once') {
        textSelected = 'One-time Purchase';
        price = document.querySelector('.check-price .price-item').textContent;
      } else {
        textSelected = 'Monthly Subscription - Save';
        price = document.querySelector('.bold-ro__initial-discount-price').textContent;
      }
    }

    if (textSelected != '') {
      document.querySelector('.recurring-type .text').textContent = textSelected;
    }
    if (price != '') {
      document.querySelector('.product__price_bold .price-item').textContent = price;
    }
  }
  document.querySelectorAll("input[name='bsub-selling-plan-group']").forEach((input) => {
    input.addEventListener('change', checkSellPlanSelected);
  });

  document.querySelector('.single-option-selector').onchange = function () {
    setTimeout(function () {
      if (document.querySelector('input[name="bsub-selling-plan-group"]:checked').value == 'once') {
        var price = document.querySelector('.check-price .price-item').textContent;
      } else {
        textSelected = 'Monthly Subscription - Save';
        var price = document.querySelector('.bold-ro__initial-discount-price').textContent;
      }

      if (price != '') {
        document.querySelector('.product__price_bold .price-item').textContent = price;
      }
    }, 500)
  }
})

function productSelectChange(select) {
  var selectedValue = jQuery(select).val();
  var priceText = jQuery(select).find(':selected').data('price');
  var comparePriceText = jQuery(select).find(':selected').data('compare-price');
  if (comparePriceText != '' && comparePriceText != priceText) {
    jQuery(select).closest('.grid-view-item').find('.price-item--regular').text(comparePriceText);
    jQuery(select).closest('.grid-view-item').find('.price-item--sale').text(priceText);
  } else {
    jQuery(select).closest('.grid-view-item').find('.price-item').text(priceText);
  }
}
